import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import PlusIcon from '../../../assets/plus-icon.svg'
import RosemaryCategoriesChildCard from './rosemaryCategoriesChildCard'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import { isEmpty } from 'lodash'

const RosemaryCategoriesCardModal = ({
  cancelCardModal,
  slideObj,
  addCallback,
  updateCallback,
  isEdit,
  categoryList,
}) => {
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [imageS3key, setImageS3key] = useState('')
  const [header, setHeader] = useState('')
  const [subHeader, setSubHeader] = useState('')
  const [childContent, setChildContent] = useState([])

  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedChildIndex, setSelectedChildIndex] = useState('')

  const [errorData, setErrorData] = useState({})
  const [dynamicErrorData, setDynamicErrorData] = useState([{ image: '', header: '' }])
  const [imageData, setImageData] = useState([])
  const [swapRender, setSwapRender] = useState(false)

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mainImg',
        width: 776,
        height: 522,
        divwidth: '11.56rem',
        divheight: '7.98rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '7px',
        btnMarginTop: '5px',
      },
    ]

    let tempChildContentArr = [
      {
        image_s3key: '',
        header: '',
        sub_header: '',
        link: {
          type: '',
          data: {},
        },
      },
    ]

    if (isEdit) {
      tempChildContentArr = slideObj.child_content
      setHeader(slideObj.header)
      setSubHeader(slideObj.sub_header)
      setImageS3key(slideObj.image_s3key)
      imgData[0]['assetId'] = slideObj.image_s3key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        slideObj.image_s3key,
      )
      let tempErr = []
      for (let index = 0; index < tempChildContentArr.length; index++) {
        tempErr.push({ image: '', header: '' })
      }
      setDynamicErrorData(tempErr)
    }

    setChildContent([...tempChildContentArr])
    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const clearDynamicError = (type, index) => {
    let temp = dynamicErrorData
    temp[index][`${type}`] = ''
    setErrorData([...temp])
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}
    let tempDynamic = dynamicErrorData

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    for (let index = 0; index < childContent.length; index++) {
      const element = childContent[index]

      if (element.header.trim().length === 0) {
        isFormValid = false
        tempDynamic[index].header = 'Header cannot be Empty!'
      }
      if (element.image_s3key.trim().length === 0) {
        isFormValid = false
        tempDynamic[index].image = 'Upload Image!'
      }
    }

    setDynamicErrorData([...tempDynamic])

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let dataObj = {
      image_s3key: imageS3key,
      header: header,
      sub_header: subHeader,
      child_content: childContent,
    }

    isEdit ? updateCallback(dataObj) : addCallback(dataObj)

    cancelCardModal()
  }

  const addNewCard = () => {
    setDynamicErrorData([...dynamicErrorData, { image: '', header: '' }])

    setChildContent([
      ...childContent,
      {
        image_s3key: '',
        header: '',
        sub_header: '',
        link: {
          type: '',
          data: {},
        },
      },
    ])
  }

  const onSwap = (index, operation) => {
    if (operation === 'up' && index > 0) {
      setChildContent((prevState) => {
        let data = [...prevState]

        let temp = data[index - 1]
        data[index - 1] = data[index]
        data[index] = temp

        return [...data]
      })
    }
    if (operation === 'down' && index < childContent.length - 1) {
      setChildContent((prevState) => {
        let data = [...prevState]

        let temp = data[index + 1]
        data[index + 1] = data[index]
        data[index] = temp

        return [...data]
      })
    }

    setSwapRender(!swapRender)
  }

  const deleteCard = (index) => {
    setSelectedChildIndex(index)
    setDeleteModal(true)
  }

  const onDeleteCard = (index) => {
    setChildContent((prevData) => prevData.filter((data, idx) => idx !== index))
    setDeleteModal(false)
    setSelectedChildIndex('')
    setSwapRender(!swapRender)
  }

  return (
    <CModal size="lg" className="category-card-modal" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader className="d-flex justify-content-center p-0 pt-3 pb-2">
        <span style={{ fontSize: '1.2rem', fontWeight: '500' }}>Add/Remove contents</span>
      </CModalHeader>
      <CModalBody style={{ padding: 0 }} className="">
        <div className="border px-5 py-3 d-flex justify-content-between">
          <div style={{ width: '25%' }} className="d-flex flex-column ">
            <h6 style={{ fontSize: '12px' }}>Carousel Banner</h6>
            <div className="text-center mt-1">
              <ImageUploader data={imageData} />
              <span className="mt-2 " style={{ fontSize: '11px', color: '#707070' }}>
                Size: 776px X 522px
              </span>
            </div>
            <div className="message-text error-message text-center">
              <p>{errorData.imageS3key}</p>
            </div>
          </div>
          <div
            style={{ width: '69.5%' }}
            className={`d-flex flex-column justify-content-center ${
              !errorData?.imageS3key && 'mt-3'
            }`}
          >
            <h6 style={{ fontSize: '12px' }}>Header</h6>
            <CustomDescriptionBox
              limit={65}
              rows={1}
              value={header}
              onChange={(value) => setHeader(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
            <h6 style={{ fontSize: '12px' }}>Sub-header</h6>
            <CustomDescriptionBox
              limit={135}
              rows={1}
              value={subHeader}
              onChange={(value) => setSubHeader(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
        </div>
        <div style={{ maxHeight: '58vh' }} className="static-scrollbar-class w-100 px-4">
          {!isEmpty(childContent) &&
            childContent.map((info, index) => (
              <RosemaryCategoriesChildCard
                data={info}
                key={index}
                index={index}
                validationError={dynamicErrorData[index]}
                categoryList={categoryList}
                clearError={(type) => clearDynamicError(type, index)}
                isEdit={isEdit}
                setChildContent={(selectedIndex, value) => {
                  let tempArr = [...childContent]
                  tempArr[selectedIndex] = value
                  setChildContent(tempArr)
                }}
                onSwap={onSwap}
                onDelete={deleteCard}
                swapRender={swapRender}
              />
            ))}
          <div
            className="w-100 d-flex flex-column justify-content-center align-items-center cursor-pointer py-3 my-4"
            style={{
              borderRadius: '4px',
              background: '#eeeeee',
              boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.3)',
            }}
            onClick={() => addNewCard()}
          >
            <div
              className="h-[23px] w-[23px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
            >
              <img src={PlusIcon} className="w-[14px] h-[14px]" alt="trashicon" />
            </div>
            <span className="text-sm font-medium mt-2 ">Add a new Content within this section</span>
          </div>
        </div>
        {deleteModal && (
          <DeleteModal
            openModal={deleteModal}
            title={`Are you sure you want to delete this Content ?`}
            confirmButtonText={`Yes`}
            onCancel={() => {
              setSelectedChildIndex('')
              setDeleteModal(false)
            }}
            onConfirm={() => onDeleteCard(selectedChildIndex)}
          />
        )}
      </CModalBody>
      <CModalFooter className="">
        <div className="py-2">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => {
              cancelCardModal()
            }}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default RosemaryCategoriesCardModal
